import React from 'react';

const Card = ({ title }) => (
    <p>{title}</p>
);

export default Card;